import { AnimatedWrenchIcon } from "@/components/ui/animated-icons/animated-wrench-icon";
import { Button } from "@/components/ui/button";

export interface ErrorOverlayProps {
  title: string;
  onRetry: () => void;
}

/**
 * Presentational error overlay for discovery tables.
 * Reused by articles table and narrative clusters table.
 */
export const ErrorOverlay = ({ title, onRetry }: ErrorOverlayProps) => (
  <div
    className="flex flex-col items-center justify-center h-full min-h-[200px]"
    style={{ pointerEvents: "auto" }}
    aria-live="polite"
  >
    <div className="flex items-center gap-2">
      <AnimatedWrenchIcon size={17} className="text-red-500" autoAnimate />
      <p className="text-sm text-red-600 font-medium">{title}</p>
    </div>
    <Button
      variant="link"
      onPress={onRetry}
      className="text-sm text-red-600 hover:text-red-700"
    >
      Try Again
    </Button>
  </div>
);
